import React from 'react';
import PrivacyPolicy from '../../../components/Mentions_legale/PrivacyPolicy/PrivacyPolicy';
import './PrivacyPolicyPage.scss';
import Footer from '../../../components/Footer/Footer';

function PrivacyPolicyPage() {
    return (
        <div className="privacy-policy-page">
            <header className="privacy-policy-header">
                <h1>Politique de confidentialité</h1>
            </header>

            <main className="privacy-policy-main">
                <PrivacyPolicy useConditionsLink={false} />
            </main>

            <Footer />
        </div>
    );
}

export default PrivacyPolicyPage;
